import SmartAlertTemplate from '@/components/SmartAlertTemplate';
import { smartAlertPageMap } from '@/data/smartAlertPages';

const page = smartAlertPageMap['concerning-language-hate-speech'];

if (!page) {
  throw new Error('Smart alert data missing for concerning language');
}

const SmartAlertConcerningLanguage = () => {
  return <SmartAlertTemplate page={page} />;
};

export default SmartAlertConcerningLanguage;


